import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "viewport"]

  connect() {
    this.currentIndex = this.slideTargets.findIndex((slide) => slide.classList.contains("news-author-articles__slide--active"))
    if (this.currentIndex < 0) {
      this.currentIndex = 0
    }

    this.showSlide(this.currentIndex)
    this.updateNavVisibility()
  }

  previous() {
    this.showSlide((this.currentIndex - 1 + this.slideTargets.length) % this.slideTargets.length)
  }

  next() {
    this.showSlide((this.currentIndex + 1) % this.slideTargets.length)
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, slideIndex) => {
      slide.classList.toggle("news-author-articles__slide--active", slideIndex === index)
    })
    this.currentIndex = index
    this.updateNavVisibility()
  }

  updateNavVisibility() {
    const showNav = this.slideTargets.length > 1
    this.element.querySelectorAll(".news-author-articles__nav").forEach((button) => {
      button.style.display = showNav ? "" : "none"
    })
  }
}
